const axios = require('axios');

export const setAuthToken = () => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export class Authentication {
  isAuthenticated() {
    const token = localStorage.getItem('accessToken');
    return !!token;
  }
}
